import React, { Component } from "react";
import { connect } from "react-redux";
import Slider from "react-rangeslider";
import "./style.css";

import Metric from "../../components/Metric";
import Container from "../../components/Container";
import Separator from "../../components/Separator";
import SeatComposition from "../../components/SeatComposition";
import { voteDataSelector } from "../../services/votedata/reducer";
import { updateVoteData } from "../../services/votedata/actions";
import { matchSelector } from "../../services/location/reducer";
import { trackSlider } from "../../services/analytics/actions";
import debounce from "./debounce";

const mapStateToProps = state => ({
  match: matchSelector(state),
  ...voteDataSelector(state)
});

class Result extends Component {
  constructor() {
    super();

    this.changeOpkomstRest = this.changeOpkomstRest.bind(this);
    this.changeOpkomstJeugd = this.changeOpkomstJeugd.bind(this);
    this.meanPercJeugd = 26;
  }

  componentDidMount() {
    const { updateVoteData, match } = this.props;
    updateVoteData(match, 57, 44);
  }

  changeOpkomstRest(value) {
    const { updateVoteData, match, opkomstJeugd } = this.props;
    updateVoteData(match, value, opkomstJeugd);
  }

  changeOpkomstJeugd(value) {
    const { updateVoteData, match, opkomstRest } = this.props;
    updateVoteData(match, opkomstRest, value);
  }

  formatNumber(number) {
    if (isNaN(number)) {
      return 0;
    }
    return Number(number.toFixed()).toLocaleString("nl-NL");
  }

  relativeAmount(perc) {
    const bandWidth = 2;

    if (perc <= this.meanPercJeugd - bandWidth) {
      return "weinig";
    }

    if (perc >= this.meanPercJeugd + bandWidth) {
      return "veel";
    }

    return "gemiddeld";
  }

  render() {
    const {
      match,
      zetelsJeugd,
      opkomstJeugd,
      opkomstRest,
      trackSlider
    } = this.props;

    const percentageYouth = (
      match.kiesgerechtigdenJeugd /
      match.kiesgerechtigden *
      100
    ).toFixed();

    return (
      <div className="result">
        <Separator />
        <Container>
          <h2>Stap 4: jouw gemeente</h2>
          <div className="result__columns">
            <div className="result__column result__column--first">
              <Metric
                value={match.kiesgerechtigdenJeugd / match.kiesgerechtigden}
              />
            </div>
            <div className="result__column">
              <p>
                In <strong>{match.name}</strong> is{" "}
                <strong>{percentageYouth}%</strong> jonger dan 35 jaar. Dat is{" "}
                <strong>{this.relativeAmount(percentageYouth)}</strong> in
                vergelijking met de rest van Nederland.
              </p>
              <p>Maar wat betekent dat voor de zetelverdeling?</p>
            </div>
          </div>
        </Container>

        <div className="result__gears">
          <h2 className="result__gear-title">{match.name}</h2>
          <SeatComposition
            amount={Number(match.zetels)}
            filledAmount={Number(zetelsJeugd.toFixed())}
            restFillType="filled"
          />
          <p>
            Als <strong>{opkomstJeugd}%</strong> van de jongeren gaat stemmen,
            is dat goed voor <strong>{this.formatNumber(zetelsJeugd)}</strong>{" "}
            zetels in de gemeenteraad.
          </p>
          <h3>Welke opkomst verwacht jij?</h3>
          <div className="result__gear">
            <p className="result__gear-label">18-35 jaar</p>
            <Slider
              className="rangeslider--alt"
              min={0}
              max={100}
              labels={{
                0: "0%",
                44: "Opkomst jongeren 2014",
                100: "100%"
              }}
              alwaysShowTooltip
              format={number => `${number}%`}
              value={opkomstJeugd}
              onChange={this.changeOpkomstJeugd}
              onChangeComplete={debounce(() => {
                trackSlider("opkomstJongeren", opkomstJeugd);
              }, 200)}
            />
          </div>
          <div className="result__gear">
            <p className="result__gear-label">35+</p>
            <Slider
              min={0}
              max={100}
              alwaysShowTooltip
              format={number => `${number}%`}
              value={opkomstRest}
              onChange={this.changeOpkomstRest}
              onChangeComplete={debounce(() => {
                trackSlider("opkomstOuderen", opkomstRest);
              }, 200)}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, { updateVoteData, trackSlider })(
  Result
);



// WEBPACK FOOTER //
// ./src/scenes/Result/index.js